// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('poPurchPlanning', {
//         templateUrl: 'views/components/views/poPurchPlanning/poPurchPlanning.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['stateService', 'utilityService', 'translateService', 'modalService', 'poPurchPlanningService', 'logisticService', 'rememberService', 'ttGridFactory', function (stateService, utilityService, translateService, modalService, poPurchPlanningService, logisticService, rememberService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             let variableNames = {
//                 businessco_no: '',
//                 stockplace_id: ''
//             };

//             vm.model = {
//                 gridReady: false,
//                 setting: {},
//                 selectListCompanies: [],
//                 selectListStockPlaces: [],
//                 switchingPoToPurchase: false
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: '',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             }).setCustomToolbarButtons([{
//                 name: 'customSave',
//                 text: '',
//                 func: () => saveItems(),
//                 icon: 'fal fa-save'
//             }]);
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await poPurchPlanningService.getPoPurchPlanning())[0];
//             }

//             async function loadCompanies() {
//                 vm.model.selectListCompanies = await logisticService.listCompanies();
//             }

//             async function loadStockPlaces() {
//                 if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                 vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                     vm.grid.dataTask.rememberId = vm.model.setting.view_id;

//                     if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true && utilityService.validateParmsValue(vm.model.setting.businessco_no) === true && utilityService.validateParmsValue(vm.model.setting.stockplace_id) === true) {
//                         vm.grid.dataTask.loadData = {
//                             method: vm.model.setting.p2_datatask_keyno,
//                             parameters: vm.model.setting
//                         };

//                         vm.model.gridReady = true;

//                         if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                     }
//                 }
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             function rememberFunc(id) {
//                 Object.keys(variableNames).forEach((key) => {
//                     variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                 });

//                 if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                 let variableValue = null;

//                 switch (id) {
//                     case 'businessco_no':
//                     case 'stockplace_id':
//                         if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     default:
//                         break;
//                 }

//                 return rememberService.remember(variableNames[id], variableValue);
//             }

//             // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = async function (value, id) {
//                 switch (id) {
//                     case 'businessco_no':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                         vm.model.setting.businessco_no = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                         await rememberFunc('businessco_no');

//                         Promise.all([
//                             loadStockPlaces()
//                         ]).then(() => {
//                             loadGrid();
//                             Promise.resolve();
//                         });

//                         break;
//                     case 'stockplace_id':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

//                         vm.model.setting.stockplace_id = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                         await rememberFunc('stockplace_id');
//                         loadGrid();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region BUTTON SWITCH PROCEDURE FUNCTION CALL

//             vm.switchChanges = function () {
//                 saveItems();
//             }

//             function saveItems() {
//                 vm.model.switchingPoToPurchase = true;

//                 let allData = vm.grid.gridfunc.getAllRows();
//                 let currentData = [];

//                 allData.forEach((item) => {
//                     if (item?.is_selected && item.is_selected === true) {
//                         currentData.push(item);
//                     }
//                 });

//                 let mergeObj = {
//                     stockplace_id: vm.model.setting.stockplace_id,
//                     pos: currentData.map(function (a) {
//                         return {
//                             "po_keyno": a.po_keyno,
//                             "supplier_no": a.supplier_no,
//                             "purchase_quantity": a.purchase_quantity,
//                             "deliverydate_wish": a.deliverydate_wish
//                         };
//                     })
//                 };

//                 poPurchPlanningService.switchToPurchase(mergeObj).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.switchingPoToPurchase = false;
//                                 }
//                             }]
//                         });
//                     } else {
//                         vm.model.switchingPoToPurchase = false;
                        
// 		                stateService.go('purchhead', { purch_internal_no: response[0].purch_internal_no });
//                     }
//                 });
//             }

//             // #endregion BUTTON SWITCH PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadSetting();
//                 loadCompanies();
//                 loadStockPlaces();
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
